import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { NewsReader } from "@/components/news/news-reader";
import type { NewsRecord } from "@/lib/news-helpers";
import { pb } from "@/lib/pb";
import { useDocumentTitle } from "@/lib/use-document-title";

/** Ported from portal-ui/app/(pages)/news/[newsId]/page.tsx. */
function newsQuery(newsId: string, authId: string | undefined) {
  return {
    queryKey: ["news", newsId, authId ?? "anon"] as const,
    queryFn: () =>
      pb.collection("news").getOne<NewsRecord>(newsId, {
        fields: "id,title,text,type,date,created,batches,students,teachers",
      }),
  };
}

export const Route = createFileRoute("/_app/news/$newsId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(newsQuery(params.newsId, pb.authStore.model?.id)),
  component: NewsDetailPage,
});

function NewsDetailPage() {
  const { newsId } = Route.useParams();
  const { data: news } = useSuspenseQuery(newsQuery(newsId, pb.authStore.model?.id));
  useDocumentTitle(news.title);
  return <NewsReader news={news} />;
}
